

<template>
  <!-- Invisible container – recaptcha v3 runs programmatically -->
  <div style="display: none"></div>
</template>

<script>
export default {
  props: {
    sitekey: {
      type: String,
      default: () => process.env.VUE_APP_RECAPTCHA_SITE_KEY || "6LdV2U4sAAAAAMTlYEt5kbOpoQaCAVtUa4gYwqiG"
    }
  },
  data() {
    return {
      captchaReady: false
    };
  },
  mounted() {
    this.loadReCaptcha();
  },
  methods: {
    loadReCaptcha() {
      if (!this.sitekey) {
        console.warn("reCAPTCHA sitekey missing (VUE_APP_RECAPTCHA_SITE_KEY).");
        return;
      }
      if (!this.loaded) {
        this.loaded=true;
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${this.sitekey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.captchaReady = true;
        };
        script.onerror = () => console.error("Failed to load reCAPTCHA script");
        document.head.appendChild(script);
      } else {
        this.captchaReady = true;
      }
    },
    /**
     * Execute reCAPTCHA v3 and resolve with the token
     */
   execute(action = "signup") {
  return new Promise((resolve, reject) => {
    if (!this.sitekey) {
      return reject(new Error("recaptcha sitekey missing"));
    }

    const run = () => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(this.sitekey, { action })
          .then(token => resolve(token))
          .catch(err => reject(err));
      });
    };

    if (typeof grecaptcha === "undefined" || !this.captchaReady) {
      const interval = setInterval(() => {
        if (typeof grecaptcha !== "undefined" && this.captchaReady) {
          clearInterval(interval);
          run();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        reject(new Error("recaptcha not ready"));
      }, 5000);
    } else {
      run();
    }
  });
}

  }
};
</script>
